import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

import { AppLoading } from '@/components/AppLoading';
import { loadAppForRoute, withStaleChunkReload } from '@/lib/loadApp';
import { RootRoute } from './RootRoute';

const App = lazy(() => loadAppForRoute().then((m) => ({ default: m.App })));
/** The privacy policy and terms, a chunk of their own: the landing page doesn't download them. */
const LegalPage = lazy(withStaleChunkReload(() => import('@/features/legal/LegalPage')));

/**
 * Every URL, first split: the public pages render on their own, without the signed-in app
 * (antd, Redux, every screen), which loads as a separate chunk for everything else. The legal
 * pages are public for everyone, signed in or not: no login, no app shell.
 */
export const RootRoutes = () => (
  <Routes>
    <Route path="/" element={<RootRoute />} />
    <Route
      path="/privacy"
      element={
        <Suspense fallback={<AppLoading />}>
          <LegalPage doc="privacy" />
        </Suspense>
      }
    />
    <Route
      path="/terms"
      element={
        <Suspense fallback={<AppLoading />}>
          <LegalPage doc="terms" />
        </Suspense>
      }
    />
    <Route
      path="*"
      element={
        <Suspense fallback={<AppLoading />}>
          <App />
        </Suspense>
      }
    />
  </Routes>
);
